import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  const footerData = {
    importantLinks: [
      { id: "footer_data_imp_link_1", name: "परिचय", link: "/parichaya" },
      {
        id: "footer_data_imp_link_2",
        name: "कर्मचारी विवरण",
        link: "/karmachari",
      },
      {
        id: "footer_data_imp_link_3",
        name: "संचालक समिति",
        link: "/sanchalak-samiti",
      },
      {
        id: "footer_data_imp_link_4",
        name: "लेखा सुपरीवेक्षण समिती",
        link: "/lekha-samiti",
      },
      {
        id: "footer_data_imp_link_5",
        name: "डाउनलोडहरू",
        link: "/download",
      },
    ],
    quickLinks: [
      {
        id: "footer_data_quick_link_1",
        name: "श्री नेपाल राष्ट्र बैंक",
        link: "https://www.nrb.org.np",
      },
      {
        id: "footer_data_quick_link_2",
        name: "भूमि व्यवस्था, सहकारी तथा गरिबी निवारण मन्त्रालय",
        link: "https://molcpa.gov.np",
      },
      {
        id: "footer_data_quick_link_3",
        name: "अर्थ मन्त्रालय",
        link: "https://mof.gov.np",
      },
      {
        id: "footer_data_quick_link_4",
        name: "महाकाली नगरपालिका",
        link: "https://aadarshkotwalmun.gov.np",
      },
    ],
  };

  return (
    <div className="footer">
      <div className="footer__contact-us">
        <h3 className="footer__tittle">सम्पर्क</h3>
        <p className="footer__para">महाकाली नगरपालिका वडा नं. ५</p>
        <p className="footer__para">
          फोन: ९८१२३४५६७८ ९८१२३२४५३२ <br></br>०९१- ९८१२३३ ०९१-०२९३२११{" "}
        </p>
        <p className="footer__para">Email: swalabmhi12@gmail.com</p>
        <img
          className="footer__image"
          src="assets/images/facebook.webp"
          alt="Facebook logo"
        />
      </div>
      <div className="footer__link-box">
        <h3 className="footer__tittle">महत्पूर्ण लिंक </h3>
        <ul className="footer__link-list">
          {footerData.importantLinks.map((el) => {
            return (
              <li className="footer__link-item" key={el.id}>
                <Link className="footer__link" to={el.link}>
                  {el.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
      <div className="footer__quick-links">
        <h3 className="footer__tittle">अन्य महत्पूर्ण लिंक</h3>
        <ul className="footer__link-list">
          {footerData.quickLinks.map((el) => {
            return (
              <li className="footer__link-item" key={el.id}>
                <Link className="footer__link" to={el.link} target="blank">
                  {el.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default Footer;
